import { useState } from "react";
import { Link } from "react-router-dom";

const Logo = ({ className = "h-16 w-auto md:h-20", to = "/" }) => {
  const [error, setError] = useState(false);
  return (
    <Link to={to} className="inline-flex items-center" data-testid="logo-link" aria-label="BÂTI 360 — Accueil">
      {error ? (
        <span className="font-display text-2xl font-extrabold tracking-tight text-bati-ink">
          BÂTI<span className="text-bati-sky">360</span>
        </span>
      ) : (
        <img src="/logo-full.webp" alt="BÂTI 360 — Rénovation tous corps d'état" className={className} onError={() => setError(true)} />
      )}
    </Link>
  );
};

export default Logo;
